import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/TemplateBase.css";
import logo from "../assets/logo.png";

const TemplateBase = ({ children }) => {
  const navigate = useNavigate();
  const nomeUsuario = localStorage.getItem("nome");
  const tipoUsuario = localStorage.getItem("tipo");


  const handleLogout = () => {
    navigate("/"); // redireciona para a tela de login
  };

  return (
    <div className="template-container">
      <header className="header">
        <div className="logo">
          <img src={logo} alt="Logo TSP" />
        </div>
        <div className="header-title">MÓDULO ADMINISTRADOR</div>

        <div style={{
          marginLeft: "auto",
          marginRight: "20px",
          display: "flex",
          alignItems: "center",
          gap: "1.5rem"
        }}>
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "center",
            color: "white",
            fontSize: "0.75rem"
          }}>
            <span>{nomeUsuario}</span>
            <span style={{ fontSize: "0.7rem", opacity: 0.8 }}>{tipoUsuario}</span>
          </div>

          <button className="logout-btn" onClick={handleLogout}>logout</button>
        </div>

      </header>

      <div className="layout">
        <nav className="sidebar">
          <ul>
            <li><Link to="/dashhome">Home</Link></li>
            <li><Link to="/clientes">Gestão de Clientes</Link></li>
            <li><Link to="/financeiro">Financeiro</Link></li>
            <li><Link to="/relatorios">Relatórios</Link></li>
            <li><Link to="/logs">Logs do Sistema</Link></li> 
            <li><Link to="/modelos-checkpoints">Modelos de CheckPoint</Link></li>
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to="/meus-dados">Meus Dados</Link></li>
            <li><Link to="/the-simon-project">The Simon Project</Link></li>
          </ul>
        </nav>

        <main className="content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default TemplateBase;

